import React from 'react';
import { Button } from 'react-bootstrap';

function CompanyButton({ title, link }) {
  const isLinkValid = title && link;

  return (
    <>
      {
        isLinkValid &&
        <Button target="_blank" href={link} className="mw-100 mb-4 company-btn">
          {title}
        </Button>
      }
    </>
  );
}

export default CompanyButton;
